module.exports = __webpack_public_path__ + "static/media/scanopro-5.ab516293.jpg";